/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import {buildCacheKey } from '@msdyn365-commerce-modules/retail-actions';
import { orderTypes } from './custom-get-sales-order-confirmation-with-hydrations.action';
import { IGCOrderTrackingInfo } from './CustomEntities/GCOrderShipmentTrackingEntity';
import { getSalesOrderTrackingInfoAsync } from './getSalesOrderTrackingInfoAsync';
import * as DataServiceEntities from './AlternateItemsEntity.g';
/**
 * GcGetOrderShipmentinfo Input Action
 */
export class GcGetOrderShipmentinfoInput implements Msdyn365.IActionInput {
      public orderType: string | undefined;

    public orderId: string | undefined;

    public confirmationId: string | undefined;

    private readonly apiSettings: Msdyn365.ICommerceApiSettings;

    public constructor(
        orderType: string | undefined,
        orderId: string | undefined,
        apiSettings: Msdyn365.ICommerceApiSettings,
        confirmationId?: string
    ) {
        this.orderType = orderType;
        this.orderId = orderId;
        this.apiSettings = apiSettings;
        this.confirmationId = confirmationId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () : string => buildCacheKey('GcGetSalesOrderShipmentinfo', this.apiSettings);
    public getCacheObjectType = () : string =>
        `GcGetSalesOrderShipmentinfo-${this.orderType ?? ''}-${this.orderId ?? ''}-${this.confirmationId ?? ''}`;
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
// export interface IGcGetOrderShipmentinfoData {
//     orderShipmentInfo: IGCOrderTrackingInfo;
// }

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createGCSalesOrderShipmentInfoInput = (args: Msdyn365.ICreateActionContext) => {
     const { salesId = '', transactionId = '', confirmationId = '' } = args.requestContext.query ?? {};
    // return new GcGetOrderShipmentinfoInput();
    if (confirmationId) {
        const orderType = undefined;
        const orderId = undefined;
        return new GcGetOrderShipmentinfoInput(orderType, orderId, args.requestContext.apiSettings, confirmationId);
    } else if (salesId) {
        return new GcGetOrderShipmentinfoInput(orderTypes.salesOrder, salesId, args.requestContext.apiSettings);
    } else if (transactionId) {
        return new GcGetOrderShipmentinfoInput(orderTypes.transaction, transactionId, args.requestContext.apiSettings);
    }

    throw new Error('gcetOrderShipmentInfo - No salesId, confirmationId or transactionId provided.');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
   export async function gcGetSalesOrderShipmentInfoAction(input: GcGetOrderShipmentinfoInput, ctx: Msdyn365.IActionContext): Promise<IGCOrderTrackingInfo> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGcGetOrderShipmentinfoData[]>('/get/example/id/1', 'get');
  const clientId=Buffer.from(ctx.requestContext.app.config.clientId,'utf8').toString('base64'); btoa(ctx.requestContext.app.config.clientId);
  const clientSecret=Buffer.from(ctx.requestContext.app.config.clientSecret,'utf8').toString('base64');
  const resource=Buffer.from(ctx.requestContext.app.config.baseUrl,'utf8').toString('base64');
  const orderTrackingUrl=Buffer.from(ctx.requestContext.app.config.axOrderTrackingUrl,'utf8').toString('base64');
  const loginUrl=Buffer.from(`https://login.microsoftonline.com/${ctx.requestContext.app.config.tenentId}/oauth2/token`,'utf8').toString('base64');
  const apiConfiguration:DataServiceEntities.IAPIConfiguration = { ClientId: clientId, ClientSecret: clientSecret, Resource: resource, GrantType:'client_credentials', APIUrl: orderTrackingUrl, LoginUrl: loginUrl};
  const trackInfo = await getSalesOrderTrackingInfoAsync({callerContext: ctx}, apiConfiguration,input.orderId??'');
  return trackInfo;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGCOrderTrackingInfo>>gcGetSalesOrderShipmentInfoAction,
    // TODO: Give your data action a unique id
    id: 'GcGetSalesOrderShipmentinfo',
    input: createGCSalesOrderShipmentInfoInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
